module.exports = require('interactive-shader-format')